import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OtherProfileService } from 'src/app/core/services/other-profile.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProfileService } from 'src/app/core/services/profile.service';
import { SuccessMessageComponent } from '../success-message/success-message.component';
import { ErrorMessageComponent } from '../error-message/error-message.component';
import { SubscribeComponent } from '../subscribe/subscribe.component';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent implements OnInit {

  @Input() currentuser;
  @Input() otherProfileData: any;

  contentLoader = true;
  loggedInUser;
  constructor(
    private activeModal: NgbActiveModal,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private _profileService: ProfileService,
    private modalService: NgbModal,
    private _otherProfileService: OtherProfileService,


  ) { }

  otherprofileIdFirstTimeTemp:any
  ngOnInit() {
    this.loggedInUser = this.authService.getCurrentUser();
    this.getLibraryPrice();

    this.otherProfileData = this._otherProfileService.otherprofileData
    console.log(this.otherProfileData,"other profile datga");

    this.otherprofileIdFirstTimeTemp = this._otherProfileService.otherprofileIdFirstTime
     console.log(this.otherprofileIdFirstTimeTemp, "otherprofileIdFirstTimeTemp");
  }

  closeDialog() {
    this.activeModal.close();
  }

  getLibraryPrice() {
    this._profileService.getUserLibraryPrice(this.currentuser.id).subscribe((response) => {
      if (response.success) {
        this.currentuser.library_price = response.data.library_price;
        this.currentuser.verification_rejected = response.data.verification_rejected;
      }
      this.contentLoader = false;
    }, (error) => {
      this.contentLoader = false;
    });
  }

  updateAutoRenew() {
    this.spinner.show();
    this._profileService.updateUserAutoRenewal(this.currentuser.subscriber_request_details.sender.subscriber_id).subscribe((response) => {
      this.spinner.hide();
      if (response.success) {
        const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        modalRef.componentInstance.message = `Auto-renewal for ${this.currentuser.business_name}'s paid subscription has been re-enabled successfully.`;
        this.activeModal.close('success');
      } else if (response.erorrs) {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = response.errors;
      }
    });
  }

  unsubscibeUser:any
  unsubscribeUserCheck:boolean =false

  unsubscribe() {
    this.spinner.show();

    var senerId =0
    if(this.otherProfileData.user.subscriber_request_details.sender.subscriber_id, typeof "undefined" )
    {
      console.log("use this ids " ,this.otherprofileIdFirstTimeTemp);
      senerId =this.otherprofileIdFirstTimeTemp
    }
    else
    {
      senerId =this.otherProfileData.user.subscriber_request_details.sender.subscriber_id
      console.log(" by service");

    }
    // console.log(this.otherProfileData.user.subscriber_request_details.sender.subscriber_id,"id pass");
    // console.log(this.currentuser,"this.currentuser.");

    this._profileService.profileUnsubscribe('unsubscribed', senerId ? senerId : this.otherProfileData.user.subscriber_request_details.sender.subscriber_id).subscribe((response) => {
      this.spinner.hide();
      if (response.success) {
        console.log("ok");

        const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        if (this.currentuser.subscriber_request_details.sender.paid_subscriber) {
          modalRef.componentInstance.message = "You have successfully canceled " + this.currentuser.business_name + "'s subscription.";
        } else {
          modalRef.componentInstance.message = "You have successfully unsubscribed " + this.currentuser.business_name;
          this.otherProfileData.user.subscriber_request_details.sender.status = response.data.connection.status;
          console.log(this.otherProfileData.user.subscriber_request_details.sender.status,"stattus change");

        }

        this.activeModal.close('success');
        // this.getSpecificUser(this.currentuser.id);
        console.log(response.data.connection,"afte unsub");
        this.unsubscibeUser
        this.unsubscribeUserCheck
        if(response.data.connection.status === "unsubscribed")
        {
          this.unsubscribeUserCheck= false
          console.log(this.unsubscribeUserCheck,"unsubscibe")

        }

      }
      else if (!response.success) {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = "Error occured unsubscribing " + this.currentuser.business_name + ".";
      }
    });
  }

  upgradeToPremium() {
    this.activeModal.close('upgrade');
  }

}
